import { useEffect, useRef, ReactNode } from "react";
import { useLocation } from "react-router";

export function RoomRefresher(
  {
    children,
    refreshNext,
    triggerRefresh,
  }: {
    refreshNext: boolean;
    triggerRefresh: () => void;
    children: ReactNode;
  }) {
  const location = useLocation();
  const prevLocationRef = useRef(location.pathname);

  useEffect(() => {
    if (prevLocationRef.current !== location.pathname && refreshNext) {
      // location has changed + refreshNext is true -> trigger reload
      triggerRefresh();
    }
  }, [location, refreshNext, prevLocationRef, triggerRefresh]);

  useEffect(() => {
    // save a ref to previous location
    prevLocationRef.current = location.pathname;
  }, [location]);

  return <>{children}</>;
}
